import { css } from "styled-components";
import { colors, darkModeColors, fonts } from "../../consts";

export const DateInputCss = css`
  // datepicker calendar styles
  .react-datepicker {
    color: ${darkModeColors.RAISIN_100_WHITE};
    background-color: ${darkModeColors.WHITE_RAISIN_100};
    transition: color 0.8s ease;

    font-family: ${fonts.PLUS_JAKARTA_SANS};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;

    border-radius: 16px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
    border: ${(props) =>
      props?.theme?.darkMode ? `1px solid rgba(110, 110, 116, 0.55)` : "unset"};
    padding: 8px;
  }

  .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
    top: ${(props) => (props?.theme?.darkMode ? `-1px` : "0")};
    border-bottom: none;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: ${darkModeColors.WHITE_RAISIN_100};
    border-bottom: 0px;
    border-radius: 16px 16px 0 0;
    padding: 0;
    position: relative;
  }

  .react-datepicker__current-month {
    color: ${colors.RAISIN_100};
  }

  // week names containers
  .react-datepicker__day-names {
    margin: unset;
    display: flex;
  }

  .react-datepicker__day-name {
    color: ${colors.RAISIN_100};

    width: 40px;
    height: 40px;
    line-height: unset;
    margin: unset;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  // dates containers
  .react-datepicker__month {
    margin: unset;
    color: ${darkModeColors.RAISIN_100_WHITE};
  }

  .react-datepicker__week {
    display: flex;
  }

  .react-datepicker__day {
    margin: unset;
    line-height: unset;
    width: 40px;
    height: 40px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    color: ${darkModeColors.RAISIN_100_WHITE};

    &:hover {
      background-color: ${darkModeColors.RAISIN_20_RAISIN_80} !important;
      color: ${darkModeColors.RAISIN_100_WHITE} !important;
      border-radius: 100px;
    }
  }

  .react-datepicker__day--today {
    font-weight: 400 !important;

    &::before {
      content: "";
      background: ${darkModeColors.RAISIN_100_WHITE};
      width: 3px;
      height: 3px;
      border-radius: 100px;
      position: absolute;
      margin-top: -25px;
    }
  }

  .react-datepicker__day--outside-month {
    color: ${colors.RAISIN_50};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-range {
    color: ${colors.WHITE} !important;
    background-color: ${colors.RAISIN_100} !important;

    &::before {
      background: ${colors.WHITE} !important;
    }
  }

  .react-datepicker__day--in-range,
  .react-datepicker__day--in-range.react-datepicker__day--keyboard-selected {
    border-radius: 0;

    &:hover {
      border-radius: 0;
    }
  }

  .react-datepicker__day--range-start,
  .react-datepicker__day--range-start.react-datepicker__day--keyboard-selected {
    border-radius: 100px 0 0 100px;

    &:hover {
      border-radius: 100px 0 0 100px;
    }
  }

  .react-datepicker__day--range-end,
  .react-datepicker__day--range-end.react-datepicker__day--keyboard-selected {
    border-radius: 0 100px 100px 0;

    &:hover {
      border-radius: 0 100px 100px 0;
    }
  }

  .react-datepicker__day--range-start.react-datepicker__day--range-end,
  .react-datepicker__day--range-start.react-datepicker__day--range-end.react-datepicker__day--keyboard-selected {
    border-radius: 100px;

    &:hover {
      border-radius: 100px;
    }
  }

  .react-datepicker__day--keyboard-selected {
    background-color: ${darkModeColors.RAISIN_20_RAISIN_80} !important;
    color: ${darkModeColors.RAISIN_100_WHITE} !important;
    border-radius: 100px;
    outline: none;
  }

  .react-datepicker__day--disabled {
    color: ${colors.RAISIN_50};
    opacity: 0.6;

    &:hover {
      background-color: unset !important;
    }
  }

  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    border-width: 2px 2px 0 0;
    width: 6px;
    height: 6px;

    border-color: ${colors.RAISIN_100};
  }
`;
